import { render, staticRenderFns } from "./workSheets.vue?vue&type=template&id=479b5783&scoped=true&"
import script from "./workSheets.vue?vue&type=script&lang=js&"
export * from "./workSheets.vue?vue&type=script&lang=js&"
import style0 from "./workSheets.vue?vue&type=style&index=0&id=479b5783&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479b5783",
  null
  
)

component.options.__file = "workSheets.vue"
export default component.exports